module.exports = __webpack_public_path__ + "img/bg_court_03.cd69bfd2.jpg";